import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { registerLocaleData } from '@angular/common';
import pt from '@angular/common/locales/pt';

import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { AvatarModule } from 'primeng/avatar';
import { TabMenuModule } from 'primeng/tabmenu';
import { DropdownModule } from 'primeng/dropdown';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { DialogModule } from 'primeng/dialog';
import { AccordionModule } from 'primeng/accordion';
import { RouterModule } from '@angular/router';
import { SkeletonModule } from 'primeng/skeleton';
import { PanelMenuModule } from 'primeng/panelmenu';
import { MenuModule } from 'primeng/menu';
import { TagModule } from 'primeng/tag';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { SetupChecklistComponent } from './pages/dashboard/setup-checklist/setup-checklist.component';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { MainLayoutComponent } from './pages/main-layout/main-layout.component';
import { LoginComponent } from './login/login.component';
import { ColaboradorFormModalComponent } from './shared/colaborador-form-modal/colaborador-form-modal.component';
import { SharedModule } from './shared/shared.module';
import { TimesRedirectComponent } from './core/components/times-redirect/times-redirect.component';

registerLocaleData(pt);

@NgModule({
  declarations: [
    AppComponent,
    DashboardComponent,
    SetupChecklistComponent,
    MainLayoutComponent,
    TimesRedirectComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    ButtonModule,
    CardModule,
    CheckboxModule,
    InputTextModule,
    ProgressSpinnerModule,
    TableModule,
    CalendarModule,
    MultiSelectModule,
    AvatarModule,
    TabMenuModule,
    DropdownModule,
    PaginatorModule,
    TooltipModule,
    ToastModule,
    DialogModule,
    AccordionModule,
    PanelMenuModule,
    MenuModule,
    TagModule,
    SkeletonModule,
    RouterModule,
    LoginComponent,
    ColaboradorFormModalComponent,
    SharedModule
  ],
  providers: [
    MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
